import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table'
import { showFile, _addNotificationError } from '../../../../server/util'
import { get } from '../../../../server/actions'

class BenefitsIssuanceListReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            dateFilter: 'all' // default to All
        }
    }

    componentDidMount = () => {
        this.getData(this.state.dateFilter);
    }

    getData = (filter = 'all', isPdf = false) => {
       this.props.showHideLoading(true);

       const schoolId = sessionStorage.getItem('SchoolId') || '';
       const currentYear = new Date().getFullYear();

       let url = `/benefits-issuance-list?schoolId=${schoolId}`;

        if (filter === 'thisYear') {
            url += `&year=${currentYear}`;
        } else if (filter === 'lastYear') {
            url += `&year=${currentYear - 1}`;
        }

        if (isPdf) {
            url += `&exportType=pdf`;
        }

        url += `&access_token=`;

        get(url)
            .then(res => {
            if (!res.ok) throw Error(res.statusText || 'Network response was not ok');
            return isPdf ? res.blob() : res.json();
            })
            .then(data => {
            if (isPdf) {
                showFile(data, `Benefits_Issuance_Report.pdf`);
            } else {
                this.setState({ data: (data && data.data) ? data.data : []  });
            }
            this.props.showHideLoading(false);
            })
            .catch((error) => {
                        let msg = '';
                        if (typeof error === 'string') msg = error;
                        else if (error && error.message) msg = error.message;
                        else msg = 'Failed to load report';
                        _addNotificationError(msg, this.props)
                        this.props.showHideLoading(false);
                    });
    };




    handleFilterChange = (e) => {
        const val = e.target.value;
        // avoid unnecessary reload if same value selected
        if (this.state.dateFilter === val) return;
        this.setState({ dateFilter: val }, () => this.getData(val));
    }

    getColumns = () => {
        let columns = [
            { Header: "Student", accessor: "studentName", width: 200, style: { textAlign: 'center' } },
            { Header: "Status", accessor: "status", width: 200, style: { textAlign: 'center' } },
            { Header: "Method", accessor: "method", width: 200, style: { textAlign: 'center' } },
            { Header: "Date", accessor: "date", width: 200, style: { textAlign: 'center' } },
        ];
        return columns
    }

    render() {
        return (<Fragment>
             <div className="row">
                <div className="col-sm-5 col-xs-5 col-sm-offset-6">
                    <div style={{ display: 'inline-flex' }}>
                        <label style={{ margin: '3px 7px' }}> Filter: </label>
                        <div>
                            <label className="rbcontainer" style={{marginRight: '10px'}}>
                                All
                                <input type="radio" name="edrange" value="all"
                                    onChange={this.handleFilterChange}
                                    checked={this.state.dateFilter === 'all'} />
                                <span className="rbcheckmark"></span>
                            </label>
                            <label className="rbcontainer" style={{marginRight: '10px'}}>
                                Last Year
                                <input type="radio" name="edrange" value="lastYear"
                                    onChange={this.handleFilterChange}
                                    checked={this.state.dateFilter === 'lastYear'} />
                                <span className="rbcheckmark"></span>
                            </label>
                            <label className="rbcontainer" style={{marginRight: '10px'}}>
                                This Year
                                <input type="radio" name="edrange" value="thisYear"
                                    onChange={this.handleFilterChange}
                                    checked={this.state.dateFilter === 'thisYear'} />
                                <span className="rbcheckmark"></span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <ReactTable className="-striped -highlight"
                        data={this.state.data}
                        columns={this.getColumns()}
                        defaultPageSize={10}
                    />
                </div>
            </div>
        </Fragment>);
    }
}

export default BenefitsIssuanceListReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/CliamReport/benefitsIssuanceReport.jsx